module.exports = __webpack_public_path__ + "static/media/three.dec156e8.svg";